// extracted by mini-css-extract-plugin
export var completionBody = "_dr-2";
export var completionCard = "_dr-0";
export var completionFooter = "_dr-3";
export var completionTitle = "_dr-1";